module.exports = __webpack_public_path__ + "src/app/assets/images/databiz_white.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/databiz_white.png
// module id = 621
// module chunks = 0